import _classCallCheck from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/createClass.js";
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getCoordsDataType } from './shader_compiler';
export var SliceProgram = /*#__PURE__*/function () {
  function SliceProgram(destSize) {
    _classCallCheck(this, SliceProgram);
    this.variableNames = ['source'];
    this.outputShape = destSize;
    this.rank = destSize.length;
    var dtype = getCoordsDataType(this.rank);
    var uniformPart = "uniform int start[".concat(this.rank, "];");
    var sourceCoords = getCoords(this.rank);
    var body;
    var coordSum = destSize.map(function (_, i) {
      return "sourceLoc.".concat(coords[i], " = start[").concat(i, "] + coords.").concat(coords[i], ";");
    });
    body = "\n        ".concat(dtype, " sourceLoc;\n        ").concat(dtype, " coords = getOutputCoords();\n        ").concat(coordSum.join('\n'), "\n      ");
    this.userCode = "\n      ".concat(uniformPart, "\n      void main() {\n        ").concat(body, "\n        setOutput(getSource(").concat(sourceCoords, "));\n      }\n    ");
  }
  _createClass(SliceProgram, [{
    key: "getCustomSetupFunc",
    value: function getCustomSetupFunc(start) {
      var _this = this;
      if (start.length !== this.rank) {
        throw Error("The rank (".concat(this.rank, ") of the program must match the ") + "length of start (".concat(start.length, ")"));
      }
      return function (gpgpu, webGLProgram) {
        if (_this.startLoc == null) {
          _this.startLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'start');
          if (_this.startLoc == null) {
            // This means the compiler has optimized and realized it doesn't need
            // the uniform.
            return;
          }
        }
        gpgpu.gl.uniform1iv(_this.startLoc, start);
      };
    }
  }]);
  return SliceProgram;
}();
var coords = ['x', 'y', 'z', 'w', 'u', 'v'];
function getCoords(rank) {
  if (rank === 1) {
    return 'sourceLoc';
  } else if (rank <= 6) {
    return coords.slice(0, rank).map(function (x) {
      return 'sourceLoc.' + x;
    }).join(',');
  } else {
    throw Error("Slicing for rank ".concat(rank, " is not yet supported"));
  }
}